import { observable } from 'mobx';

class RouterStore {
  @observable accessor activeRoute = '';
  @observable accessor prevRoute = '';
}

const RouterData = new RouterStore();

export default RouterData;
